export default "__VITE_ASSET__ae00a8d1__"